'use client';

import type { ReactNode } from 'react';
import { useSelectedLayoutSegment } from 'next/navigation';
import ExperienceLayer from '@/world/ExperienceLayer';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import LiveActivity from '@/components/overlays/LiveActivity';
import Intro from '@/components/overlays/Intro';
import AskLab from '@/ai/AskLab';
import BehaviorEngine from '@/intelligence/BehaviorEngine';
import HintLayer from '@/intelligence/HintLayer';
import ConsentLayer from '@/intelligence/ConsentLayer';

/** Command owns its viewport, conversation and live connection. Other routes
 * retain the shared laboratory world and its single SSE subscription. */
export default function RouteShell({
  children,
  skipLabel,
}: {
  children: ReactNode;
  skipLabel: string;
}) {
  const command = useSelectedLayoutSegment() === 'command';

  return (
    <>
      <a href="#content" className="skip-link">{skipLabel}</a>
      {!command && <>
        <ExperienceLayer />
        <Intro />
        <SiteHeader />
      </>}
      <main id="content" tabIndex={-1}>{children}</main>
      {!command && <>
        <SiteFooter />
        <LiveActivity />
        <AskLab />
        <HintLayer />
        <ConsentLayer />
        <BehaviorEngine />
      </>}
    </>
  );
}
